import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import {connect} from "react-redux";
import "./Product.css";
import payment from "./images/payment.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft,faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Card from 'react-bootstrap/Card'
import Loader from './../../_components/loader/loader';
import getProducts from './../../_actions/productActions';
//display of list products 17/06/2023
import Utils from "../../_helpers/utils";
import tile from "./images/tile.svg";
import list from "./images/list.svg";

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      view: "grid",
      isMobile:true,
    };
  }

  componentDidMount() {
    this.props.getProducts();
    //find diff of device
    if(Utils.isMobileDevice()) {
      this.setState({
        view: "grid",
        isMobile:true
      });  
    }
    else {
      this.setState({
        view: "list",
        isMobile:false
      });
    }
  }
  //change view of list
  changeView(view) {
    this.setState({view: view});    
  }

  routeChange(path) {
    this.props.history.push(path);
  }

  render() {
    console.log(this.props);
    const { loading } = this.state;
    return (
      <div className="Product">
        {
          <Container fluid>
              <div className="module-header">
                <div className="module-header-inner blue-light-card">
                <div className="back">
                  <FontAwesomeIcon icon={ faArrowLeft } onClick={this.props.history.goBack} />
                </div>
                  <img src={payment} alt="Products" /> 
                </div>
                <div className="arrow-set">
                  {
                    this.state.isMobile ?
                    <div className="row">  
                      <div className="col-10">
                        <h3>Products</h3>
                      </div>
                      <div className="col-2">
                        {this.state.view === 'list'? <img alt="list" src={tile} className="border"  onClick={() => this.changeView('grid')} />: <img alt="grid" src={list} className="border"  onClick={() => this.changeView('list')}/> }
                      </div>
                    </div>
                    :
                    <h4>Products</h4>
                  }
                </div>
              </div>
              {loading ?  <Loader />: this.state.view === 'list'? this.renderCard() : this.renderGrid()}           
          </Container>
        }
      </div>
    );
  }

  renderCard() {
	  console.log(this.props.product);
		return  <div className="card_list"> 
		{
      this.props.product && this.props.product.map((item, index) => {
			return ( 
			    <Card key={index} onClick={() => this.routeChange('/products/' + item.id + '/' + item.name)}>
				<Card.Body>
				  <div className="cardbody">
					<img src={item.imageUrl} alt={item.name} />
					<h4 className="head">{item.name}</h4>
					{/*<FontAwesomeIcon icon={ faArrowRight }  />*/}
				  </div>
				</Card.Body>
			  </Card>
			)
      })
    }
    </div>
  }

//renderGrid
renderGrid() {
  console.log(this.props.product);
  return  <div className="mobile_course_list"> 
  {
    this.props.product && this.props.product.map((item, index) => {
    return (
      <div key={index} onClick={() => this.routeChange('/products/' + item.id + '/' + item.name)}>
          <div className="row">
            <div className="col-12">
              <div className="course_box">
                <div className="card">
                  <img alt={item.name} src={item.imageUrl} className="img img-responsive" />
                  <div className="head">
                    <p className="title"><strong>{item.name}</strong></p>
                  </div>
                </div> 
              </div>
            </div> 
          </div>
      </div>
    )
    })
  }
  </div>
}

}

const mapStateToProps = state => ({
  product: state.product.product
});

const mapDispatchToProps = {
  getProducts: getProducts,
};

/*const mapDispatchToProps = dispatch => ({
  getResource: () => dispatch(getResource())
});*/


export default connect(mapStateToProps,mapDispatchToProps) (Product);
